import { render, staticRenderFns } from "./congratulations_on_becoming.vue?vue&type=template&id=61b62eed&scoped=true"
import script from "./congratulations_on_becoming.vue?vue&type=script&lang=js"
export * from "./congratulations_on_becoming.vue?vue&type=script&lang=js"
import style0 from "./congratulations_on_becoming.vue?vue&type=style&index=0&id=61b62eed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b62eed",
  null
  
)

export default component.exports